import React from 'react'
import { Route, Switch } from 'react-router'
import UserLoginsList from './UserLoginsList'

const Users = props => (
    <Switch>
        <Route exact path={props.match.url} component={UserLoginsList} />
    </Switch>
)

export default Users
